<template>
  <div class="tkpaymentApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <div class="card">
      <ul>
        <li>
          <h3>{{proDetail.title}}</h3>
          <div class="price"><font>游玩日期：</font>{{proDetail.starttime}} 至 {{proDetail.endtime}}</div>
          <div class="noty"><i class="el-icon-warning-outline"></i>购票须知</div>
          <div class="g" v-html="proDetail.content"></div>
          <div class="noty">费用明细</div>
          <div class="cash">
            <p>
              <span>包含景点</span>
              <font>{{card.title}}</font>
            </p>
            <p>
              <span>门票数量</span>
              <font>{{card.num}}张</font>
            </p>
            <p style="border-bottom:none">
              <span>应支付金额</span>
              <font style="color:red;font-size:12px">￥<b>{{proDetail.rate}}</b></font>
            </p>
          </div>
          <div class="noty">出行人信息<font>（请输入准确信息，以免影响入园）</font></div>
          <div class="info">
            <p>
              <span><font color="red">*</font>姓名</span>
              <input type="text" v-model="name" placeholder="请输入姓名" value="" />
            </p>
            <p>
              <span><font color="red">*</font>手机号</span>
              <input type="number" v-model="phone" placeholder="请输入手机号" value="" />
            </p>
            <p>
              <span><font color="red">*</font>身份证号</span>
              <input type="text" v-model="idCard" placeholder="请输入身份证号" value="" />
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div style="height:55px"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>合计：<i>￥</i><b>{{proDetail.rate}}</b>
        </span>
        <span>含{{card.num}}张门票</span>
      </div>
      <div class="pay" @click="payment">
        <span>立即购买</span>        
      </div>
    </div>


  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        proDetail:[],
        card:[],
        userData:[],
        name:'',
        phone:'',  
        idCard:'', 
        attest:[],
        code:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.attest1();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      attest1:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/ticket/attest',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.name = res.name;
          that.phone = res.phone;
          that.idCard = res.card;
          that.fullscreenLoading = false;
        }).catch(err=>{
          that.fullscreenLoading = false
        });
      },

      payment:function(){
        var that = this;
        if(that.name == ''){
          that.$alert('请输入出行人姓名！!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.phone == ''){
          that.$alert('请输入出行人手机号！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.idCard == ''){
          that.$alert('请输入出行人身份证号！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        var id = this.$route.query.id;
        var uid = this.$route.query.uid;

        that.axios({
          method:'post',
          url:that.$host+'home/ticket/weixinPay',
          params:{
            id:id,
            user_id:that.userData.id,
            phone:that.phone,
            uid:uid,
            name:that.name,
            idCard:that.idCard,
            pay_money:that.proDetail.rate
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.callpay(res);
          }else{
            that.$alert('请核实信息后重新支付', '提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/scenicOrder?id=2";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
      getDetail:function(){
        var id = this.$route.query.id;
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/ticket/index',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;

          that.proDetail = res.rs;
          that.card = res.card;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%;
    padding-bottom:20px
  }
  .tkpaymentApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .tkpaymentApp .card ul{
    width:94%;
    display:block;
    margin:0 auto;
    background:#fff;
    border-radius: 6px;
    margin-bottom:15px;
    padding-bottom:15px
  }
  .tkpaymentApp .card ul li{
    width:100%;
    position:relative;
  }
  .tkpaymentApp .card ul li h3{
    font-size:16px;
    padding:15px 15px 10px 15px;
    letter-spacing:1.5px
  }


  .tkpaymentApp .card ul li .price{
    font-size:15px;
    padding:0 15px 20px 15px;
  }
  .tkpaymentApp .card ul li .noty{
    width:92%;
    display:block;
    margin:0 auto;
    font-size:15px;
    font-weight:bold;
  }
  .tkpaymentApp .card ul li .noty i{
    padding-right:5px;
    color:#f00;
  }
  .tkpaymentApp .card ul li .noty font{
    font-size:12px;
    font-weight:normal;
    color:#666
  }
  .tkpaymentApp .card ul li .g{
    width:92%;
    display:block;
    margin:0 auto;
    font-size:13px;
    padding:5px 0;
    line-height:22px;
    text-indent: 2em;
    color:#666
  }
  .tkpaymentApp .card ul li .cash{
    width:92%;
    display:block;
    margin:0 auto;
    padding-bottom:15px
  }
  .tkpaymentApp .card ul li .cash p{
    height:50px;
    border-bottom:solid 1px #f5f5f5
  }
  .tkpaymentApp .card ul li .cash span{
    float:left;
    width:25%;
    height:50px;
    line-height:50px;
    margin-left:5%;
    font-size:14px;
    color:#666
  }
  .tkpaymentApp .card ul li .cash font{
    float:right;
    line-height:50px;
    font-size:14px;
    height:50px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .tkpaymentApp .card ul li .cash font b{
    font-size:16px
  }

  .tkpaymentApp .card ul li .info{
    width:92%;
    display:block;
    margin:10px auto 0 auto;
    background:#f5f5f5;
    border-radius: 6px;
  }
  .tkpaymentApp .card ul li .info p{
    height:50px;
  }
  .tkpaymentApp .card ul li .info span{
    float:left;
    width:22%;
    height:50px;
    line-height:50px;
    margin-left:5%;
    font-size:15px;
    color:#666
  }
  .tkpaymentApp .card ul li .info input{
    float:left;
    line-height:35px;
    font-size:14px;
    height:35px;
    border:none;
    width:67%;
    margin-top:8px;
    padding:0 5px;
    outline:none;
  }

  .tkpaymentApp .footer1{
    height: 50px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0;
    z-index: 1
  }
  .tkpaymentApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .tkpaymentApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
  }
  .tkpaymentApp .footer1 .foot-title span:first-child{
    margin-right:8px
  }
  .tkpaymentApp .footer1 .foot-title span b{
    color: #f00;
    font-size:17px;
    font-weight:500;
  }

  .tkpaymentApp .footer1 .foot-title span i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }

  .tkpaymentApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .tkpaymentApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #FF751A;
    border-radius:40px;
  }
  .tkpaymentApp #el-drawer__title span{
    text-align:center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #2F78FF;
  }

  .tkpaymentApp .el-drawer__wrapper ul{
    width:90%;
    margin:0 auto;
  }
  .tkpaymentApp .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .tkpaymentApp .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .tkpaymentApp .el-drawer__wrapper li p{
    padding-bottom:10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }
  .tkpaymentApp .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .tkpaymentApp .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .tkpaymentApp .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }

  .tkpaymentApp .el-drawer__wrapper .append{
    background:#2F78FF;
    color:#fff;
    position:absolute;
    right:20px;
    top:25%;
    font-size:14px;
    padding:5px 10px;
    border-radius: 10px
  }
 
</style>